import { chain } from "wagmi";
import v1NftsAbi from "./abis/v1Nft.abi.json";
import v2NftsAbi from "./abis/v2Nft.abi.json";
import fancyBearsAbi from "./abis/fancyBears.abi.json";
import honeyJarsAbi from "./abis/honeyJars.abi.json";
import honeyVestingAbi from "./abis/honeyVesting.abi.json";
import honeyConsumptionAbi from "./abis/honeyConsumption.abi.json";
import honeyAbi from "./abis/honey.abi.json";
import traitsAbi from "./abis/traits.abi.json";
import traitSaleAbi from "./abis/traitSale.abi.json";
import traitStakingAbi from "./abis/traitStaking.abi.json";
import v2SaleAbi from "./abis/v2Sale.abi.json";
import hiveAbi from "./abis/hive.abi.json";
import multicallAbi from "./abis/multicall.abi.json";
import en from "./locales/en.json";
import { Currency } from "types";

export { default as theme } from "./theme";

export const projectName = process.env.REACT_APP_PROJECT_NAME!;
export const v1Name = process.env.REACT_APP_V1_NAME!;
export const v2Name = process.env.REACT_APP_V2_NAME!;

export const environment = process.env.NODE_ENV;

export const publicUrl = process.env.PUBLIC_URL;
export const apiUrl = process.env.REACT_APP_API_URL;

export const v1MetadataUrl = process.env.REACT_APP_V1_METADATA_URL;
export const v2MetadataUrl = process.env.REACT_APP_V2_METADATA_URL;

export const v1FilesUrl = process.env.REACT_APP_V1_FILES_URL;
export const v2FilesUrl = process.env.REACT_APP_V2_FILES_URL;
export const traitsFilesUrl = process.env.REACT_APP_TRAITS_FILES_URL;
export const fancyBearsFilesUrl = process.env.REACT_APP_FANCY_BEARS_FILES_URL;

export const chainName = process.env.REACT_APP_CHAIN_NAME;
export const infuraId = process.env.REACT_APP_INFURA_ID;

export const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

// @ts-expect-error
export const chains = [chain[process.env.REACT_APP_CHAIN_NAME!]];

export const v1Contract = {
  address: process.env.REACT_APP_V1_ADDRESS!,
  interface: v1NftsAbi,
};

export const v2Contract = {
  address: process.env.REACT_APP_V2_ADDRESS!,
  interface: v2NftsAbi,
};

export const fancyBearsContract = {
  address: process.env.REACT_APP_FANCY_BEARS_ADDRESS!,
  interface: fancyBearsAbi,
};

export const honeyJarsContract = {
  address: process.env.REACT_APP_HONEY_JARS_ADDRESS!,
  interface: honeyJarsAbi,
};

export const honeyTokenContract = {
  address: process.env.REACT_APP_HONEY_TOKEN_ADDRESS!,
  interface: honeyAbi,
};

export const honeyVestingContract = {
  address: process.env.REACT_APP_HONEY_VESTING_ADDRESS!,
  interface: honeyVestingAbi,
};

export const honeyConsumptionContract = {
  address: process.env.REACT_APP_HONEY_CONSUMPTION_ADDRESS!,
  interface: honeyConsumptionAbi,
};

export const traitsContract = {
  address: process.env.REACT_APP_TRAITS_ADDRESS!,
  interface: traitsAbi,
};

export const traitSaleContract = {
  address: process.env.REACT_APP_TRAIT_SALE_ADDRESS!,
  interface: traitSaleAbi,
};

export const traitStakingContract = {
  address: process.env.REACT_APP_TRAIT_STAKING_ADDRESS!,
  interface: traitStakingAbi,
};

export const v2SaleContract = {
  address: process.env.REACT_APP_V2_SALE_ADDRESS!,
  interface: v2SaleAbi,
};

export const hiveContract = {
  address: process.env.REACT_APP_HIVE_ADDRESS!,
  interface: hiveAbi,
};

export const multicallContract = {
  address: process.env.REACT_APP_CHAIN_MULTICALL_ADDRESS!,
  interface: multicallAbi,
};

export const locales = {
  en,
};

export const defaultCurrency = Currency.Eth;

export const fancyBearsSupply = parseInt(
  process.env.REACT_APP_FANCY_BEARS_SUPPLY!,
  10
);
export const v1Supply = parseInt(process.env.REACT_APP_V1_SUPPLY!, 10);

export const honeyUniswapUrl = process.env.REACT_APP_HONEY_UNISWAP_URL;
export const ethUniswqpUrl = process.env.REACT_APP_ETH_UNISWAP_URL;

export const v1OpenSeaUrl = process.env.REACT_APP_V1_OPENSEA_URL!;
export const v2OpenSeaUrl = process.env.REACT_APP_V2_OPENSEA_URL!;
export const fancyBearsOpenSeaUrl =
  process.env.REACT_APP_FANCY_BEARS_OPENSEA_URL!;

export const openSeaAssetBaseUrl = process.env.REACT_APP_OPENSEA_ASSET_BASE_URL;

export const learnMoreUrl = process.env.REACT_APP_LEARN_MORE_URL;

export const featureFlags = {
  traitsSwapping:
    process.env.REACT_APP_FEATURE_TRAITS_SWAPPING &&
    process.env.REACT_APP_FEATURE_TRAITS_SWAPPING === "1",
};
